import { Spin } from 'antd';
import download from 'downloadjs';
import moment from 'moment';
import React, { useState } from 'react';
import { AiOutlineCloudDownload } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import Apis from '../../../../../../api';
import { RootState } from '../../../../../../store/rootReducer';
import MessageActions from '../../../../../message/redux/actions';
import { Reporting } from '../../../redux/types';

type Props = {
    reports: Reporting[];
    date: string;
};

const ReportingObligationDoc: React.FC<Props> = ({ reports, date }) => {
    const issuerUUID = useSelector((state: RootState) => state.investments.investmentDetails?.issuer?.issuerUUID);
    const dispatch = useDispatch();

    const [docDownloadLoading, setDocDownloadLoading] = useState<string | undefined>(undefined);

    const reportingObligations = useSelector((state: RootState) => state.investments.reportingObligations);

    const data = reportingObligations.find((d) => d.obligationDate?.date === date)?.reports;

    const downloadFile = (reportUUID: string, docName: string) => {
        if (reportUUID && issuerUUID) {
            setDocDownloadLoading(reportUUID);
            Apis.downloadReporting(issuerUUID, reportUUID)
                .then((res) => {
                    download(
                        new Blob([res.data], { type: res.headers['content-type'] }),
                        docName,
                        res.headers['content-type'],
                    );
                })
                .catch((err) => {
                    dispatch(MessageActions.showMessage({ text: String(err), error: true }));
                })
                .finally(() => {
                    setDocDownloadLoading(undefined);
                });
        }
    };

    return (
        <div>
            {/** Document box Header */}
            <ReportingObligationHeader />
            {[...new Map(reports.map((item) => [item['obligationType'], item])).values()].map((d, index) => (
                <div
                    className="my-2 mb-4 border  rounded "
                    key={`${d.obligationType}_${index}_${new Date().getMilliseconds()}`}
                    style={{ borderColor: '#E5E5E5' }}
                >
                    {/** Header */}
                    <div
                        className="rounded py-2 px-3 grid grid-cols-12 gap-4 items-center"
                        style={{ rowGap: '0rem', backgroundColor: '#F4F7FD' }}
                    >
                        <div className="col-span-12 WorkSans text-xs font-normal" style={{ color: '#404040' }}>
                            <p>{d.obligationType}</p>
                        </div>
                        {(data?.find((r) => r.obligationType === d.obligationType)?.uploadDetails || []).filter(
                            (d) => d.status === 'Rejected',
                        ).length > 0 && (
                            <p className="col-span-12 text-xs text-red-500 WorkSans font-normal">
                                Alert there are 1 or more documents that require re-submission. Please review and submit
                                them again.
                            </p>
                        )}
                    </div>
                    {/** End Header */}
                    {/** Document List */}
                    <div className="py-4 px-3">
                        {(data?.find((r) => r.obligationType === d.obligationType)?.uploadDetails || []).map(
                            (doc, index1) => (
                                <div
                                    className="grid grid-cols-12 gap-4 py-1"
                                    key={`${index}_${index1}_${doc.obligationType}_${
                                        doc.uuid
                                    }_${new Date().getMilliseconds()}`}
                                >
                                    <p
                                        className="col-span-6 min-h-[24px] WorkSans font-normal cursor-pointer text-xs flex items-center"
                                        style={{ color: '#404040' }}
                                    >
                                        {doc.title}
                                    </p>
                                    <p
                                        className="col-span-4 WorkSans font-normal text-xs flex items-center"
                                        style={{ color: '#404040' }}
                                    >
                                        {doc.audit.updatedAt
                                            ? moment(doc.audit.updatedAt).format('DD/MM/YYYY hh:mm:ss')
                                            : ''}
                                    </p>
                                    <div className="flex items-center justify-center col-span-2">
                                        {docDownloadLoading !== doc.uuid && (
                                            <AiOutlineCloudDownload
                                                size={'1.4rem'}
                                                color="#182D4F"
                                                className="cursor-pointer"
                                                onClick={() => {
                                                    if (!docDownloadLoading) downloadFile(doc.uuid, doc.title);
                                                }}
                                            />
                                        )}
                                        {docDownloadLoading === doc.uuid && <Spin size="small" />}
                                    </div>
                                </div>
                            ),
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ReportingObligationDoc;

const ReportingObligationHeader = () => {
    return (
        <div className="grid grid-cols-12 gap-4 py-1 px-3 pt-4">
            <p className="col-span-6 WorkSans text-xs font-bold" style={{ color: '#182D4F' }}>
                Document Type
            </p>
            <p className="col-span-4 WorkSans font-bold text-xs" style={{ color: '#182D4F' }}>
                Uploaded On
            </p>
            <p className=" text-xs flex font-bold justify-center col-span-2 WorkSans" style={{ color: '#182D4F' }}>
                Download
            </p>
        </div>
    );
};
